import React from 'react';
import { Table } from 'reactstrap';
//import Presenter from '../../../presenter.js';
//import RequestProperties from '../../request.props.js';

// Request prop for maintenance
import PresenterMaintenance from 'maintenance/presenter.js';
import RequestPropertiesMaintenance from 'maintenance/helper/request.props.js';

import { toast } from 'react-toastify';

// Modal Start Work And Finish
import ModalStartWork from 'maintenance/helper/component/Modal/ModalStartWork.js';
import ModalFinishWork from 'maintenance/helper/component/Modal/ModalFinishWork.js';

import Request from 'config/Request.js'

// Component
import MaintenanceRow from '../Row/MaintenanceRow.js';

import ModalMaintenanceAdd from 'maintenance/helper/component/Modal/ModalMaintenanceAdd.js'
import ModalMaintenanceEdit from 'maintenance/helper/component/Modal/ModalMaintenanceEdit.js'

import ModalReminderEdit from 'remainder/helper/component/Modal/ModalRemainderEdit.js';
import ModalReminderAdd from 'remainder/helper/component/Modal/ModalRemainderAdd.js';

import windowStop from 'utils/windowStop.js'


/**
|--------------------------------------------------
| inAdmin is used in page admin, and
| inUser is used in modalDetailMyAsset
|--------------------------------------------------
*/
const URL = {
  'inAdmin': 'read-maintenance-by-asset',
  'inUser': 'read-asset-maintenance',
}

export default class TabMaintenance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalStartWork: false,
      modalFinishWork: false,
      modalAdd: false,
      tmpRemainder: false,
      modalAddReminder: false,
      modalEditReminder: false,

      // Modal update reminder
      update: false,
      updateData: [],
      
      work: {
        alias: '',
      },

      rawData: [],
      nextPage: null,
    }

    this.openModalStartWork     = this.openModalStartWork.bind(this)
    this.closeModalStartWork    = this.closeModalStartWork.bind(this)

    this.openModalFinishWork    = this.openModalFinishWork.bind(this)
    this.closeModalFinishWork   = this.closeModalFinishWork.bind(this)

    this.onStartWork            = this.onStartWork.bind(this)
    this.onStartWorkSuccess     = this.onStartWorkSuccess.bind(this)
    this.onStartWorkFailed      = this.onStartWorkFailed.bind(this)

    this.onQuickTest            = this.onQuickTest.bind(this)
    this.onQuickTestSuccess     = this.onQuickTestSuccess.bind(this)
    this.onQuickTestFailed      = this.onQuickTestFailed.bind(this)
    
    // this.onFinishWork           = this.onFinishWork.bind(this)
    this.onFinishWorkSuccess    = this.onFinishWorkSuccess.bind(this)
    this.onFinishWorkFailed     = this.onFinishWorkFailed.bind(this)

    this.onLoad = this.onLoad.bind(this)
    this.onLoadSuccess = this.onLoadSuccess.bind(this)
    this.onLoadFailed = this.onLoadFailed.bind(this)

    // toggle 
    this.toggleModalAdd = this.toggleModalAdd.bind(this) 

    this.offTmpRemainder        = this.offTmpRemainder.bind(this);

    this.loading = true;
    this.params_page = 1
  }

  /**
  |--------------------------------------------------
  | Open & Close Modal Start 
  |--------------------------------------------------
  */
  openModalStartWork(alias){
    this.setState({
      work : {
        alias : alias,
      },
      modalStartWork : true
    })
  }

  closeModalStartWork(){
    this.setState({ modalStartWork : false })
  }

  toggleModalAdd() {
    this.setState({modalAdd: !this.state.modalAdd})
  }

  /**
  |--------------------------------------------------
  | open & close modal edit maintenance
  |--------------------------------------------------
  */
  openModalEdit = (data) => {
    this.setState({
      RowData: data,
      modalEdit: true
    })
  }

  closeModalEdit = () => {
    this.setState({
      modalEdit: false
    })
  }

  offTmpRemainder() {
    this.setState({tmpRemainder: false})
  }

  /**
  |--------------------------------------------------
  | Open & Close Modal Reminder add
  |--------------------------------------------------
  */
  openModalReminderAdd = (alias) => {
    this.setState({
      work: {
        alias: alias
      },
      modalAddReminder: true,
      tmpRemainder: true
    })
  }

  closeModalReminderAdd = () => {this.setState({modalAddReminder: false})}

  updateRow = (update) => {
    this.setState({update: update})
  }

  /**
  |--------------------------------------------------
  | Open & Close Modal Reminder edit
  |--------------------------------------------------
  */

  openModalReminderEdit = (data) => {this.setState({updateData: data,modalEditReminder: true})}
  closeModalReminderEdit = () => {this.setState({modalEditReminder: false})}  

  /**
  |--------------------------------------------------
  | Open & Close Modal Finish 
  |--------------------------------------------------
  */
  openModalFinishWork(alias){
    this.setState({
      work : {
        alias : alias,
      },
      modalFinishWork : true
    })
  }

  closeModalFinishWork(){
    this.setState({ modalFinishWork : false })
  }


  /**
  |--------------------------------------------------
  | Function Start Work
  |--------------------------------------------------
  */
  onStartWork(data) {
    PresenterMaintenance.StartWork(
      RequestPropertiesMaintenance.StartWork(data, this, this.onStartWorkSuccess, this.onStartWorkFailed)
    )
  }

  onStartWorkSuccess(params, response) {
    toast.success("Execute Success")
    this.params_page = 1
    this.onLoad();
    this.closeModalStartWork();
  }

  onStartWorkFailed(response) {
    toast.error(response.data.detail);
  }


  /**
  |--------------------------------------------------
  | Function Quick Test
  |--------------------------------------------------
  */
  onQuickTest(alias) {
    PresenterMaintenance.QuickTest(
      RequestPropertiesMaintenance.QuickTest(alias, this, this.onQuickTestSuccess, this.onQuickTestFailed)
    )
  }
  onQuickTestSuccess(params, response) {
    toast.success("Quick Test Success")
    this.params_page = 1
    this.onLoad();
  }
  onQuickTestFailed(response) {
    try {
      toast.error(response.data.detail); 
    } catch (error) {
      console.log(error)
    }
  }

  /**
  |--------------------------------------------------
  | Function Finish Work
  |--------------------------------------------------
  */
  onFinishWorkSuccess(params, response) {
    this.params_page = 1
    this.onLoad();
    this.closeModalFinishWork();
  }

  onFinishWorkFailed(response) {
    console.log('Failed');
  }
  
  generateRow(row) {
  	var element = row.map((val, index) => {
  		return (
        <MaintenanceRow 
          key={index}
          RowData={val}
          onStartWork={this.openModalStartWork}
          onStartQuickTest={this.onQuickTest}
          onFinishWork={this.openModalFinishWork}
          history={this.props.history}
          dataAsset={this.props.SelectedItem}
          usedFor={this.props.usedFor}
          openModalEdit={this.openModalEdit}
          UserReducer={this.props.UserReducer}
        />
      )
  	})
  	return element;
  }

  onLoad(extra) {

    let asset_alias = null

    try {
      asset_alias = this.props.SelectedItem.Alias  
    } catch (error) {
      console.log("Selected item don't have asset alias")
    }
    
    Request(
      'get',
      URL[this.props.usedFor],
      {Authorization: "Bearer " + this.props.UserReducer.token},
      {page: this.params_page},
      [asset_alias],
      this.onLoadSuccess,
      this.onLoadFailed,
      extra,
    )

  }

  onLoadSuccess(response, extra) {
    this.loading = false

    if(extra === 'next') {
      this.setState({
        rawData: [...this.state.rawData, ...response.data.results],
        nextPage: response.data.next,
        loadingLoadMore: false
      })
    } else {
      this.setState({
        rawData: response.data.results,
        nextPage: response.data.next,
        loadingLoadMore: false
      })
    }
    
  }

  onLoadFailed(error) {
    this.loading = false
    this.setState({
      loadingLoadMore: false
    })
  }

  // LOADMORE
  LoadMore() {        
    this.setState({
      loadingLoadMore: true,
    })

    if(this.state.nextPage) {
      this.params_page += 1
    }

    this.onLoad('next')
  }

  RenderLoadMoreButton() {
    if(this.state.loadingLoadMore) {
      return(
        <div>
          <button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button>
        </div>
      )
    } else {
      if(this.state.nextPage != null) {
        return (
          <div>
            <button className="btn btn-primary" onClick={()=> {this.LoadMore()}}>Load More</button>
          </div>
        )
      }
    }
  }

  componentDidMount() {
    this.onLoad();
  }

  componentWillUnmount() {
    windowStop()
  }

	RenderRowElement() {
		if(this.loading) {
			return (        
				<tr>
          <td className="table-loading-inside" colSpan="100%">Loading data . . .</td>
        </tr>
			)
		} else if(this.state.rawData.length > 0) {
			return (this.generateRow(this.state.rawData))
		} else {
			return (
				<tr>
          <td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td>
        </tr>
			)
		}
	}

  render() {
    return (
      <div>
      	<div className="list-separator">
          <div className="item-inner">
            Maintenance &nbsp; 
            {this.props.usedFor === 'inAdmin' && <button className="btn btn-primary btn-sm" onClick={()=>this.toggleModalAdd()} >Add Maintenance</button>}
          </div>
        </div>
      	<Table className="table table-striped table-responsive m-top-15">
      		<thead>
      			<tr>
      				<th>Maintenance</th>
      				<th>Scheduled Start</th>
      				<th>Scheduled End</th>
              {this.props.usedFor === 'inAdmin' && <th className="text-center">Reminder</th>}
              {this.props.usedFor === 'inAdmin' && <th className="text-center">Edit</th>}
              <th className="text-center">Action</th>
      			</tr>
      		</thead>
      		<tbody>
      			{this.RenderRowElement()}
      		</tbody>
      	</Table>
        <div className="col-md-12 text-center">
          {this.RenderLoadMoreButton()}
        </div>

        <ModalStartWork
          modalStartWork  = {this.state.modalStartWork}
          work            = {this.state.work}
          closeModal      = {this.closeModalStartWork}
          onStartWork     = {this.onStartWork}
          UserReducer     = {this.props.UserReducer}
        />

        <ModalFinishWork
          modalFinishWork     = {this.state.modalFinishWork}
          work                = {this.state.work}
          closeModal          = {this.closeModalFinishWork}
          onFinishWorkSuccess = {this.onFinishWorkSuccess}
          onFinishWorkFailed  = {this.onFinishWorkFailed}
          UserReducer         = {this.props.UserReducer}
        />

        <ModalMaintenanceAdd 
          toggleModalAdd = {this.toggleModalAdd}
          modalAdd       = {this.state.modalAdd}
          UserReducer    = {this.props.UserReducer}
          loadData       = {this.onLoad}
          assetData      = {this.props.SelectedItem}
        />

        <ModalMaintenanceEdit 
          modalEdit             = {this.state.modalEdit}
          closeModalEdit        = {this.closeModalEdit}
          RowData               = {this.state.RowData}
          UserReducer           = {this.props.UserReducer}
          loadData              = {this.onLoad}

          openModalReminderEdit = {this.openModalReminderEdit}
          openModalReminderAdd  = {this.openModalReminderAdd}
          tmpRemainder          = {this.state.tmpRemainder}
          offTmpRemainder       = {this.offTmpRemainder} 
        />

        <ModalReminderAdd 
          modalRegister = {this.state.modalAddReminder}
          closeModal    = {this.closeModalReminderAdd}
          UserReducer   = {this.props.UserReducer}
          updateRow     = {this.updateRow}
          newRow        = {this.updateRow}
          work          = {this.state.work}
        />

        <ModalReminderEdit 
          modalEdit   = {this.state.modalEditReminder}
          updateData  = {this.state.updateData}
          UserReducer = {this.props.UserReducer}
          updateRow   = {this.updateRow}
          closeModal  = {this.closeModalReminderEdit}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Tab/TabMaintenance.js